export const DEFAULT_TENANT = 'default';

const TENANT_SAFE_RE = /^[a-z0-9_-]+$/i;

export function sanitizeTenantId(value?: string | null): string | null {
  if (!value) {
    return null;
  }

  return TENANT_SAFE_RE.test(value) ? value : null;
}

export function coerceTenantId(value?: string | null, fallback = DEFAULT_TENANT): string {
  return sanitizeTenantId(value) || fallback;
}
